import React from 'react';
import { Box } from '@mui/material';

const DrawerHeader = ({ children, sx = {}, id = 'addDrawer-headerBox', ...props }) => {
  return (
    <Box
      id={id}
      sx={{
        pl: 3.7,
        pr: 2,
        py: 2.15,
        borderBottom: '1px solid',
        borderColor: 'divider',
        ...sx
      }}
      {...props}
    >
      {children}
    </Box>
  );
};

export default DrawerHeader;
